export default {
  carrierLabelSingular: {
    id: 'carrier_label_singular',
    defaultMessage: 'Only works with:',
  },
  carrierLabelPlural: {
    id: 'carrier_label_plural',
    defaultMessage: 'Works with:',
  },
  carrierTooltipUnlockedNew: {
    id: 'carrier_tooltip_unlocked_new',
    defaultMessage:
      'Works with: {carrier}, {count, plural, one{# and any carrier that operates on this network} other{# as well as any carrier that operates on at least one of these networks} } and offers a BYOD program.',
  },
  carrierTooltipLockedNew: {
    id: 'carrier_tooltip_locked_new',
    defaultMessage: 'This locked phone will only work with {carrier}',
  },
}
